import React, {Component} from 'react';
import MembGrade from './membGrade';
// import MemberRight from './memberRight';
// import MemberFAQ from './memberFAQ';
import Header from '../components/header';
import Footer from '../components/footer';
import {Route} from 'react-router-dom';
import ClubSidebar from '../components/clubSidebar'
import '../less/global.less'
import '../less/club.less';


class Club extends Component {
    constructor(props) {
        super(props)
        this.params = {}
        this.params.sideList = [
            {
                className:'icon-mebship',
                bigtit:'Jin Jiang Rewards',
                littit:[
                    {litName:'Member Tiers',path:'/'},
                    // {litName:'Member Points And Benefits',path:'/memberRight'},
                    // {litName:'FAQ',path:'/memberFAQ'},
                ]
            }
        ]
    }


    render() {
        const { sideList } = this.params
        return (
            <div className="club">
                <Header/>
                <div className="banner"></div>
                <div className="club-main">
                    <div className="club-container">
                        <ClubSidebar sideList={sideList} />
                        <div className="club-right-container">
                            <Route exact path={`/`}  component={MembGrade}/>
                            {/* <Route exact path={`/memberRight`}  component={MemberRight}/>
                            <Route exact path={`/memberFAQ`}  component={MemberFAQ}/> */}
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}


export default Club;
